import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Home from "../Layout/Home";
import Sidebar from "../Layout/Sidebar";
import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Contexts/Auth/AuthContext";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  // console.log('in dashboard main component');
  const [count, setCount] = useState({});
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(process.env.REACT_APP_EXPRESS_URL + "/posts-count", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("linkedin-scheduler-token")
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("linkedin-scheduler-token");
          return (window.location.href = "/login");
        }
        return;
      }

      const data = await response.json();

      const array = [];

      data.data.forEach((element) => {
        array[element._id] = element.count;
      });

      setCount(array);
      // console.table(array);

      console.table(data.data);

      // console.log(data.data.client_id,data.data.client_secret,data.data.token)
      // setCount(data.data)
    };

    fetchData();
  }, []);

  return (
    <main className="pt-26 flex-1 p-6">
  {/* <h2 className="text-2xl font-semibold mb-6">Welcome to your Dashboard</h2> */}
  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
    <h2 className="text-l font-semibold">Dashboard</h2>
    <div className="text-l text-gray-400 mt-2 md:mt-0">
      Home
    </div>
  </div>
  {/* WIDGETS */}
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-6">
    <div className="bg-gray-800 rounded-lg p-6 shadow-md hover:shadow-lg transition">
      <h3 className="text-lg font-medium mb-2 text-gray-300">Published Posts</h3>
      <p className="text-3xl font-bold text-white">{count.publish ?? 0}</p>
    </div>
    <div className="bg-gray-800 rounded-lg p-6 shadow-md hover:shadow-lg transition">
      <h3 className="text-lg font-medium mb-2 text-gray-300">Draft Postss</h3>
      <p className="text-3xl font-bold text-white">{count.draft ?? 0}</p>
    </div>
    <div className="bg-gray-800 rounded-lg p-6 shadow-md hover:shadow-lg transition">
      <h3 className="text-lg font-medium mb-2 text-gray-300">Scheduled Posts</h3>
      <p className="text-3xl font-bold text-white">{count.scheduled ?? 0}</p>
    </div>
  </div>

  {/* MAIN CONTENT PLACEHOLDER */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div className="bg-gray-800 rounded-lg p-6 shadow-md">
      <h5 className="text-l font-semibold text-white mb-3">Want to know how to configure?</h5>
      <ol className="text-gray-400 list-decimal list-inside space-y-2">
        <li>
          Create a page for your linkedin account on which you want to post the content.
        </li>
        <li>
          Login on the <a target="_blank" href="https://developer.linkedin.com/">Linkedin Developer Portal.</a>
        </li>
        <li>
          After logging go to create an app section.
        </li>
        <li>
          Choose a name for your app and enter the url of the page that you created.
        </li>
        <li>
          On successfull creation of the app, you will have to verify tha page once.
        </li>
        <li>
          After that go to auth section of your app, there you will find the client id and client secret. Copy paste them here in inside configurations section.
        </li>
        <li>
          After that using OAuth 2.0 tools, generate a new token and choose the given scopes. Then copy paste that token as well here. You can refer to this <a target="_blank" href="https://learn.microsoft.com/en-us/linkedin/shared/authentication/developer-portal-tools?context=linkedin%2Fcontext">documentation</a> for geenrating a token.
        </li>
        <li>
          Then you will be able to successfully save the configurations.
        </li>
      </ol>
      <button onClick={() => {navigate("/panel/configurations")}} className="mt-2 bg-blue-600 hover:bg-blue-500 text-white font-medium py-2 px-4 rounded transition">
        Start configuring
      </button>
    </div>
    <div className="bg-gray-800 rounded-lg p-6 shadow-md">
      <h5 className="text-l font-semibold text-white mb-3">Want to know how to start creating posts?</h5>
      <ol className="text-gray-400 list-decimal list-inside space-y-2">
        <li>
          Open the posts section and click on the plus icon to create a new post                  
        </li>
        <li>
          Enter a name for the post, it is just for your reference and it will not pe posted on the linkedin.                  
        </li>
        <li>
          Enter the content that you want to post on linedin in the content box                  
        </li>
        <li>
          Select the status as published or draft. If you dont want to publish a post ye then you can choose the draft status.                  
        </li>
        <li>
          If you have selected status as published and you dont select any publish time, then the post will be immediately posted. If you want the content to be posted at some other time then seelct that particular time and post will automatically be posted.
        </li>
      </ol>
      <button onClick={() => {navigate("/panel/post")}} className="mt-2 bg-blue-600 hover:bg-blue-500 text-white font-medium py-2 px-4 rounded transition">
        Create your first post
      </button>
    </div>
  </div>
  {/* <p className="text-gray-400">This is where your main content will go.</p> */}
</main>

  //   <body class="bg-gray-900 text-white min-h-screen flex">

  //   <main class="flex-1">

  //     <div class="p-6 border-b border-gray-700 flex items-center justify-between">
  //       <h1 class="text-3xl font-semibold">Dashboard</h1>
  //       <div class="text-sm text-gray-400">
  //         <a href="#" class="hover:underline">Home</a> / <span class="text-white">Dashboard</span>
  //       </div>
  //     </div>

  //     <div class="p-6">
  //       <p class="text-gray-400 text-sm mb-6">Overview of your activity</p>

  //       <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
  //         <div class="bg-gray-800 p-6 rounded-lg shadow-md border border-gray-700">
  //           <h3 class="text-lg font-semibold text-gray-300 mb-2">Posts Scheduled</h3>
  //           <p class="text-3xl font-bold text-white">12</p>
  //         </div>

  //         <div class="bg-gray-800 p-6 rounded-lg shadow-md border border-gray-700">
  //           <h3 class="text-lg font-semibold text-gray-300 mb-2">Posts Drafted</h3>
  //           <p class="text-3xl font-bold text-white">8</p>
  //         </div>

  //         <div class="bg-gray-800 p-6 rounded-lg shadow-md border border-gray-700">
  //           <h3 class="text-lg font-semibold text-gray-300 mb-2">Total LinkedIn Accounts</h3>
  //           <p class="text-3xl font-bold text-white">3</p>
  //         </div>
  //       </div>
  //     </div>
  //   </main>
  // </body>
  );
};

export default Dashboard;
